// extracted by mini-css-extract-plugin
export var testimonials = "testimonials-module--testimonials--SKyY-";
export var testimonial = "testimonials-module--testimonial--1lifb";
export var speech = "testimonials-module--speech--1utPJ";
export var name = "testimonials-module--name--1yGWQ";